<template>
    <v-app class="homepage homepage-b2b api-soft">
        <div class="homepage__container homepage__white homepage__container-header">
            <v-container class="main-block">
                <v-layout wrap row class="homepage__title-layout px-0">
                    <v-flex xs12 md8 class="api-soft__title">
                        <h2>Getpolis SOFT - цифровое рабочее место страхового агента по продаже ОСАГО</h2>
                    </v-flex>
                    <v-flex xs12 md7 class="api-soft__subtitle">
                        <p>
                            Getpolis SOFT — это единый кабинет для ваших прямых договоров и доступа к 20+ страховым компаниям.
                            Сохраняйте комиссию и экономьте от 98 минут на каждом просчёте анкеты.
                        </p>
                    </v-flex>
                    <v-flex xs12 class="api-soft__buttons buttons-block">
                        <div d-block class="button-block">
                            <v-btn
                                class="button next-button block v-btn"
                                @click="openBitrixDialog"
                            >
                                Подключиться уже сейчас
                            </v-btn>
                        </div>
                        <div d-block class="button-block">
                            <v-btn
                                class="button prev-button block v-btn"
                            >
                                Подробнее о продукте
                            </v-btn>
                        </div>
                    </v-flex>
                    <v-flex xs12 md8 class="api-soft__text">
                        <p class="top">Устали от рутинного ввода данных в кабинеты десятков СК?</p>
                        <p class="bottom">
                            Мы разработали инструмент, который позволяет вам работать по всем вашим прямым агентским
                            договорам и дополнительно получать предложения от 15+ наших партнерских компаний в одном
                            расчете. Вы вводите данные один раз и мгновенно предлагаете клиенту лучшее решение на рынке.
                        </p>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-container class="second-block">
                <v-layout class="b2b-slider">
                    <v-carousel
                        hide-delimiters
                    >
                        <v-carousel-item
                            v-for="(item,i) in items"
                            :key="i"
                            :interval="3000"
                            :src="item.src"
                            reverse-transition="fade-transition"
                            transition="fade-transition"
                        ></v-carousel-item>
                    </v-carousel>
                </v-layout>
                <div class="flex b2b-green-circle"></div>
            </v-container>
        </div>

        <div class="homepage__container homepage__grey">
            <v-container class="homepage__container-why-choose-us" id="chooseContainer">
                <p class="homepage__container-why-choose-us__title">Не на словах, а на деле даём конкретные плюсы для каждого агента</p>
                <v-layout class="homepage__container-why-choose-us__inner" wrap row>
                    <v-layout class="homepage__container-why-choose-us__block-with-inner" wrap row>
                        <v-flex wrap row id="choose1_1" xs12 md5>
                            <v-flex class="homepage__container-why-choose-us__block left-block">
                                <v-flex xs12 class="homepage__container-why-choose-us__block__column">
                                    <h4>Сохранение комиссии 100%</h4>
                                    <p>
                                        Все вознаграждения по вашим агентским договорам поступают напрямую от страховых
                                        компаний на ваш счет. Условия и размер комиссии остаются неизменными.
                                        Ваша выгода: Вы ничего не теряете в деньгах и условиях.
                                    </p>
                                </v-flex>
                                <v-flex xs12 class="homepage__container-why-choose-us__block__column">
                                    <h4>Революционная экономия времени</h4>
                                    <p>
                                        Один расчёт по 20 СК занимает до 2 минут, а расчёт в кабинете одной СК занимает
                                        от 5 минут. Ваша выгода: Вы тратите 2 минуты вместо 100 на
                                        подбор оптимального предложения.
                                    </p>
                                </v-flex>
                            </v-flex>

                        </v-flex>
                        <v-flex wrap row id="choose1_2" xs12 md7>
                            <v-flex class="homepage__container-why-choose-us__block">
                                <v-flex xs12 class="homepage__container-why-choose-us__block__column">
                                    <h4>Максимальное удержание клиентов</h4>
                                    <p>
                                        Если одна СК не одобрила заявку, вы сразу подбираете альтернативное решение в
                                        том же расчете. Ваша выгода: Вы на 100% закрываете потребность клиента.
                                    </p>
                                </v-flex>
                                <v-flex xs12 class="homepage__container-why-choose-us__block__column">
                                    <h4>Мобильность<br>и доступность</h4>
                                    <p>
                                        Полнофункциональный кабинет всегда<br>под рукой — в вашем телефоне/планшете.<br>
                                        Ваша выгода: Вы всегда на связи<br>и можете оформить полис клиенту<br>
                                        за 2 минуты, даже не находясь в офисе.
                                    </p>
                                    <img width="220" src="/img/home/3.png" class="hidden-sm-and-down" />
                                    <img src="/img/home/ipad_pro.png" class="right-bottom-float-image hidden-sm-and-down" />
                                    <img width="280" src="/img/home/ipad_iphone.png" class="right-bottom-float-image hidden-md-and-up" />
                                </v-flex>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-layout>

                <v-layout class="homepage__container-why-choose-us__inner" wrap row>
                    <v-layout class="homepage__container-why-choose-us__block-with-inner bottom-block" wrap row>
                        <v-flex wrap row id="choose2_1" xs12>
                            <v-flex class="homepage__container-why-choose-us__block emoji-block">
                                <v-flex xs12 md4 class="homepage__container-why-choose-us__block__column">
                                    <div class="emoji-block__wrapper">
                                        <img src="/img/home/emoji/money-bag.png">
                                        <img src="/img/home/emoji/thumbs-up.png">
                                    </div>
                                    <p>
                                        Окупаемость с первых продаж — уже при <span>5 проданных ОСАГО</span> подписка полностью
                                        покрывает себя и увеличивает чистую прибыль.
                                    </p>
                                </v-flex>
                                <v-flex xs12 md4 class="homepage__container-why-choose-us__block__column">
                                    <div class="emoji-block__wrapper">
                                        <img src="/img/home/emoji/woman-technologist.png">
                                        <img src="/img/home/emoji/chain.png">
                                    </div>
                                    <p>
                                        Получить консультацию или подключить GetPolis Soft прямо сейчас?
                                    </p>
                                </v-flex>
                                <v-flex xs12 md4 class="homepage__container-why-choose-us__block__column">
                                    <div class="emoji-block__wrapper">
                                        <img src="/img/home/emoji/writing-hand.png">
                                        <img src="/img/home/emoji/desktop-computer.png">
                                    </div>
                                    <p>
                                        Звоните или пишите всё сделаем быстро и качественно!
                                    </p>
                                </v-flex>
                                <v-flex xs12>
                                    <v-btn
                                        class="button next-button block v-btn"
                                        @click="openBitrixDialog"
                                    >
                                        Подключиться и начать продавать больше.
                                    </v-btn>
                                </v-flex>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-layout>
            </v-container>
        </div>

        <div class="homepage__container homepage__white api-soft">
            <v-container class="api-soft__container-digital-workplace" id="digitalWorkplace">
                <v-layout class="api-soft__container-digital-workplace__title-layout" px-0>
                    <v-flex class="api-soft__container-digital-workplace__title" xs12 md9>
                        <h3>Цифровое рабочее место: Инструменты Getpolis SOFT для контроля и роста продаж</h3>
                    </v-flex>
                </v-layout>
                <v-layout class="api-soft__container-digital-workplace__main-points-layout" px-0>
                    <v-flex class="api-soft__container-digital-workplace__main-points" xs12 md9>
                        <div class="block">
                            <h4><b>Автоматизация работы с пролонгацией:</b><br>Встроенный инструмент работает как <b>мини-CRM.</b></h4>
                            <div class="block__small">
                                <p>Функции напоминания, комментарии, переносы дат.</p>
                                <p>
                                    Если СК изменила условия, вы мгновенно подберете новое предложение из
                                    <b>20+ компаний без переноса данных вручную.</b>
                                </p>
                                <p>Результат: Ни один клиент не будет потерян и не останется без лучшего предложения.</p>
                            </div>
                        </div>
                        <div class="block">
                            <h4><b>Единый доступ к договорам:</b> Все ваши прямые договоры со СК плюс доступ к <b>20+
                                нашим партнерским компаниям</b> (при необходимости можно отключить) в одном личном кабинете.</h4>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>

        <div class="homepage__container homepage__white api-soft">
            <v-container class="api-soft__container-partners" id="partners">
                <v-layout class="api-soft__container-partners__title-layout" px-0>
                    <v-flex class="api-soft__container-partners__title">
                        <h3>С какими страховыми компаниями работает Getpolis SOFT по продукту ОСАГО</h3>
                    </v-flex>
                </v-layout>
                <v-layout class="api-soft__container-partners__list-layout" px-0>
                    <v-flex class="api-soft__container-partners__list">
                        <div class="block">
                            <h4><b>Готовые к интеграции</b></h4>
                            <div class="block__logos">
                                <div class="block__logos__logo" v-for="(partner, index) in partnersApprove" :key="index">
                                    <img :src="partner.img" alt="logo">
                                </div>
                            </div>
                        </div>
                        <div class="block">
                            <h4><b>В стадии реализации</b></h4>
                            <div class="block__logos">
                                <div class="block__logos__logo" v-for="(partner, index) in partnersFuture" :key="index">
                                    <img :src="partner.img" alt="logo">
                                </div>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout class="api-soft__container-partners__info-layout">
                    <v-flex class="api-soft__container-partners__info" xs12 md9>
                        <div class="block">
                            <h4>Представлен список компаний с которыми мы уже работаем и которые появятся в скором времени</h4>
                            <div class="block__small">
                                <p>Гибкость: API-ключи можно подключать по мере заключения Ваших новых агентских договоров</p>
                                <p><b>15+ партнерских компаний</b> всегда доступны в едином расчете</p>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>

        <div class="homepage__container homepage__grey api-soft">
            <v-container class="api-soft__container-connection" id="connection">
                <v-layout class="api-soft__container-connection__title-layout" px-0>
                    <v-flex class="api-soft__container-connection__title">
                        <h3>Начните зарабатывать больше. Простая схема подключения.</h3>
                    </v-flex>
                </v-layout>
                <v-layout class="api-soft__container-connection__main-block-layout" px-0>
                    <v-flex class="main-block-conditions" xs12 md7>
                        <h4>Условия оплаты:</h4>
                        <div class="main-block-conditions__points">
                            <p><b>Включено:</b> Подключение <b>до 5 страховых компаний</b> по вашему выбору.</p>
                            <p><b>Дополнительная СК: +1 000 Р/месяц</b> к базовому тарифу.</p>
                            <p>Важно: Вы можете начать даже с одной компании и добавлять новые в любой момент.</p>
                        </div>
                        <div class="main-block-conditions__prices">
                            <p class="main-block-conditions__prices__old">10 000 ₽/месяц.</p>
                            <p class="main-block-conditions__prices__new">3 000 ₽/месяц</p>
                        </div>
                        <v-btn
                            class="button next-button block v-btn"
                            @click="openBitrixDialog"
                        >
                            Купить
                        </v-btn>
                    </v-flex>
                    <v-flex class="main-block-process" xs12 md5>
                        <h4>Процесс подключения:</h4>
                        <div class="main-block-process__step">
                            <div class="main-block-process__circle"></div>
                            <div class="main-block-process__content">
                                <p class="main-block-process__step-title">1 Шаг</p>
                                <p><b>Вы</b> отправляете нам свои реквизиты.<br>
                                    <b>Мы</b> делаем лицензионный договор.</p>
                            </div>
                        </div>
                        <div class="main-block-process__step">
                            <div class="main-block-process__circle"></div>
                            <div class="main-block-process__content">
                                <p class="main-block-process__step-title">2 Шаг</p>
                                <p><b>Вы</b> передаёте нам API-ключи (запрашиваются у Ваших кураторов в Страховых Компаниях).<br>
                                    <b>Мы</b> подключаем Страховые Компании.</p>
                            </div>
                        </div>
                        <div class="main-block-process__step">
                            <div class="main-block-process__circle"></div>
                            <div class="main-block-process__content">
                                <p class="main-block-process__step-title">3 Шаг</p>
                                <p><b>Вы</b> оплачиваете наш счёт.<br>
                                    <b>Мы</b> активируем Ваш доступ.</p>
                            </div>
                        </div>
                    </v-flex>

                </v-layout>
                <v-layout class="api-soft__container-connection__timer-layout" px-0>
                    <v-flex class="api-soft__container-connection__timer">
                        <h4>До конца действия цены</h4>
                        <div class="timer-wrapper">
                            <div class="timer-wrapper__numbers">
                                <p class="number">{{ days }}</p>
                                <p class="text">Дни</p>
                            </div>
                            <p>:</p>
                            <div class="timer-wrapper__numbers">
                                <p class="number">{{ hours }}</p>
                                <p class="text">Часы</p>
                            </div>
                            <p>:</p>
                            <div class="timer-wrapper__numbers">
                                <p class="number">{{ minutes }}</p>
                                <p class="text">Минуты</p>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>

        <div class="homepage__white">
            <v-container class="homepage__container-reviews">
                <v-layout wrap row class="homepage__container-reviews__wrapper">
                    <div class="homepage__container-reviews__header">
                        <h2>Отзывы действующих<br>агентов</h2>
                        <div class="homepage__container-reviews__header__buttons">
                            <div class="button-left" @click="scrollLeft">
                                <img src="/img/home/arrow-right.svg" alt="left" style="transform: rotate(180deg)">
                            </div>
                            <div class="button-right" @click="scrollRight">
                                <img src="/img/home/arrow-right.svg" alt="right">
                            </div>
                        </div>
                    </div>

                    <div class="homepage__container-reviews__main" ref="reviewsContainer">
                        <div class="review-block" v-for="(item, index) in reviewsArray" :key="index">
                            <div class="review-block__top">
                                <div class="review-block__top__agent">
                                    <p class="name">{{ item.name }}</p>
                                    <p class="city">{{ item.city }}</p>
                                </div>
                                <div class="review-block__top__text">
                                    <p class="text">{{ item.text }}</p>
                                </div>
                            </div>
                            <div class="review-block__bottom">
                                <div class="review-block__bottom__stars">
                                    <div class="star" v-for="(star, index) in item.stars" :key="index">
                                        <img src="/img/home/star.svg" alt="star">
                                    </div>
                                </div>
                                <div class="review-block__bottom__date">
                                    <p class="date">дата</p>
                                    <p>{{ item.date }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-layout>
            </v-container>
        </div>

        <div class="homepage__container homepage__white api-soft">
            <v-container class="homepage__container-faq api-soft__faq">
                <h2>Частые вопросы</h2>
                <home-questions
                    :faq="faq"
                />
                <v-flex wrap row class="homepage__container-faq__any-question api-soft__any-question">
                    <h3>Остались вопросы?</h3>
                    <v-flex class="homepage__container-faq__any-question__text">
                        <p>По любым вопросам пишите на <a href="mailto:mail@getpolis.ru">mail@getpolis.ru</a>, или звоните 8 800 201 06 43.<br>Расскажем, проконсультируем.</p>
                        <a class="black-button" @click="openFeedback">Задать вопрос</a>
                    </v-flex>
                </v-flex>
                <v-btn
                    class="button next-button block v-btn faq-button"
                    @click="openBitrixDialog"
                >
                    Стать партнёром Getpolis
                </v-btn>
            </v-container>
        </div>
        <homepage-feedback
            :dialog="dialog"
            @closeFeedback="closeFeedback"
        />
        <bitrix-form
            :dialog="bitrixDialog"
            @closeBitrixDialog="closeBitrixDialog"
        />
    </v-app>
</template>

<script>
export default {
    data: () => ({
        dialog: false,
        bitrixDialog: false,
        items: [
            {
                src: '/img/b2b_slider/macbook.png',
            },
            {
                src: '/img/b2b_slider/ipad.png',
            },
            {
                src: '/img/b2b_slider/iphone.png',
            },
        ],
        partnersApprove: [
            {
                img: '/img/ingosstrah.svg',
            },
            {
                img: '/img/soglasie.svg',
            },
            {
                img: '/img/rosgosstrah.svg',
            },
            {
                img: '/img/partners/energo_garant.svg',
            },
            {
                img: '/img/maks.svg',
            },
            {
                img: '/img/sk21vek.svg',
            },
            {
                img: '/img/vsk.png',
            },
            {
                img: '/img/zetta.png',
            },
            {
                img: '/img/yugoria.svg',
            },
            {
                img: '/img/partners/absolute.svg',
            },
            {
                img: '/img/partners/astro-volga.svg',
            },
        ],
        partnersFuture: [
            {
                img: '/img/partners/pari-grey.png',
            },
            {
                img: '/img/borovitskoe-grey.svg',
            },
            {
                img: '/img/sogaz-grey.svg',
            },
            {
                img: '/img/partners/alfa.png',
            },
            {
                img: '/img/partners/sovkombank.png',
            },
            {
                img: '/img/partners/reness.png',
            },
            {
                img: '/img/sber-grey.svg',
            },
            {
                img: '/img/gelios-grey.svg',
            },
        ],
        reviewsArray: [
            {
                name: 'Денис, 36 лет',
                city: 'Нижний Новгород',
                text: 'Был в трёх агрегаторах. Только здесь пошёл поток: без отказов, без багов. \n' +
                    'За день 5 полисов — 4100₽ на карте.',
                stars: 5,
                date: '28.05.2024',
            },
            {
                name: 'Светлана',
                city: 'Агент из Ростова',
                text: 'Клиент заплатил — я сразу вижу деньги. Поддержка помогает, не исчезают. Всё чётко.',
                stars: 5,
                date: '29.05.2024',
            },
            {
                name: 'Игорь, 34 года',
                city: 'Москва',
                text: 'Я не агент, но оформляю по 5–6 полисов в день. Гетполис — как раз то, чего не хватало. Всё чётко.',
                stars: 5,
                date: '30.05.2024',
            },
            {
                name: 'Максим, 28 лет',
                city: 'Екатеринбург',
                text: 'Работал через другую платформу — постоянные отказы. Здесь — стабильно. Первый день — 3 полиса, 2700₽ на карту.',
                stars: 5,
                date: '30.05.2024',
            },
        ],
        faq: [
            {
                question: 'Как работает Getpolis?',
                answer: 'Наша платформа сравнивает для Вас цены по всем ТОП страховым компаниям. Вам остается только выбрать наиболее подходящие предложение, оплатить и распечатать страховой полис.'
            },
            {
                question: 'Как начать работу?',
                answer: 'Просто зарегистрируйтесь у нас на сайте за 1 минуту и начинайте продажи.'
            },
            {
                question: 'Кому подойдет наш сервис?',
                answer: 'Наш сервис подойдет Вам, если: <ul>' +
                    '<li>у Вас своя агентская сеть</li>' +
                    '<li>Вы страховой агент или брокер</li>' +
                    '<li>Вы в поисках дополнительного заработка</li>' +
                    '<li>Вы работаете или связаны с автобизнесом</li>' +
                    '<li>Вы собственник сайта по тех осмотрам или КБМ</li>' +
                    '<li>Вы работаете в сфере недвижимости или с этой сферой связаны</li>' +
                    '<li>Вы являетесь собственником или сотрудником станции техосмотра</li>' +
                    '<li>Вы собственник сайта или приложения с большим трафиком посетителей</li>' +
                    '</ul>'
            },
            {
                question: 'Сколько времени потребуется?',
                answer: 'Регистрация занимает не более 1-ой минуты, а оформление договора ОСАГО или ИПОТЕКИ не более 5-ти.'
            },
            {
                question: 'Какие договоры можно заключать?',
                answer: 'На платформе доступно оформление ОСАГО и ИПОТЕКИ. Остальные продукты в процессе реализации, но Ваш персональный куратор поможет Вам в ручном режиме оформить любой страховой продукт.'
            },
            {
                question: 'Как получать выплаты?',
                answer: 'Самозанятые и физлица могут вывести деньги на банковскую карту. Юридические лица и ИП получают вознаграждение на расчетные счета.'
            },
            {
                question: 'В каких регионах можно страховать?',
                answer: 'Оформляйте клиентов со всей территории РФ. Не нужно отказывать клиенту, если у него не местная прописка или не проходит сегментацию.'
            },
        ],
        days: '00',
        hours: '00',
        minutes: '00',
        timer: null,
    }),
    mounted() {
        this.startCountdown();
    },
    methods: {
        scrollLeft() {
            const container = this.$refs.reviewsContainer;
            const blockWidth = container.children[0].offsetWidth + 16; // 16 — твой gap
            if (container.scrollLeft <= 0) {
                container.scrollLeft = container.scrollWidth;
            }
            container.scrollLeft -= blockWidth;
        },
        scrollRight() {
            const container = this.$refs.reviewsContainer;
            const blockWidth = container.children[0].offsetWidth + 16;
            if (container.scrollLeft + container.offsetWidth >= container.scrollWidth) {
                container.scrollLeft = 0;
            } else {
                container.scrollLeft += blockWidth;
            }
        },
        openFeedback() {
            this.dialog = true
        },
        closeFeedback() {
            this.dialog = false
        },
        openBitrixDialog() {
            this.bitrixDialog = true
        },
        closeBitrixDialog() {
            this.bitrixDialog = false
        },
        startCountdown() {
            this.updateCountdown(); // сразу обновим
            this.timer = setInterval(this.updateCountdown, 1000 * 60); // обновляем каждую минуту
        },
        updateCountdown() {
            const now = new Date();

            // текущий день месяца
            const currentDay = now.getDate();

            // следующий месяц
            const year = now.getFullYear();
            const month = now.getMonth() + 1; // следующий месяц

            // 1. Проверяем сколько дней в следующем месяце
            const daysInNextMonth = new Date(year, month + 1, 0).getDate();

            // 2. Если текущего дня не существует в следующем месяце → берём последний
            const targetDay = Math.min(currentDay, daysInNextMonth);

            // 3. Формируем дату окончания
            const targetDate = new Date(year, month, targetDay, 0, 0, 0);

            const diff = targetDate - now;

            if (diff <= 0) {
                // месяц наступил → пересчитываем снова
                this.startCountdown();
                return;
            }

            const totalMinutes = Math.floor(diff / 1000 / 60);
            const days = Math.floor(totalMinutes / (60 * 24));
            const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
            const minutes = totalMinutes % 60;

            this.days = String(days).padStart(2, '0');
            this.hours = String(hours).padStart(2, '0');
            this.minutes = String(minutes).padStart(2, '0');
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/ApiSoft.vue